/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class LogsIcon extends BaseIcon {
  getChildren = () => [ <path d="M13,15H4a1,1,0,0,1-1-1V2H6A1,1,0,0,1,7,1h3a1,1,0,0,1,1,1h3V14A1,1,0,0,1,13,15ZM4,4V14h9V4Zm1,8V11h7v1ZM5,9h7v1H5ZM5,7h7V8H5Z" fill={this.getColor()}/> ]
  getViewBox = () => '0 0 16 16'
}
